import { render, staticRenderFns } from "./PointsHistoryUpdateLog.vue?vue&type=template&id=553f80d5"
import script from "./PointsHistoryUpdateLog.vue?vue&type=script&lang=js"
export * from "./PointsHistoryUpdateLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports